<template>
  <div>
    <div :class="$style.box" @touchmove.prevent>
      <div :class="$style.tip">
        <div :class="$style.close" @click="HIDDEN_TIP">
          <img :src="close" alt />
        </div>
        <div :class="$style.title">{{ tip_title }}</div>
        <div :class="$style.info">
          <p v-for="(item, index) in tip_info" :key="index">{{ item }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from "@/config";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      close: `${CDN_URL}/packet/close.png`,
    };
  },
  computed: {
    ...mapState("packet", {
      tip_title: "tip_title",
      tip_info: "tip_info",
    }),
  },
  methods: {
    ...mapMutations("packet", {
      HIDDEN_TIP: "HIDDEN_TIP",
    }),
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: $Tip-mask;
  .tip {
    width: 278px;
    height: 201px;
    background: rgba(255, 255, 255, 1);
    border-radius: 11px;
    margin: 220px auto;
    position: relative;
    .close {
      width: 40px;
      height: 40px;
      // background-color: black;
      position: absolute;
      right: 0;
      top: 0;
      > img {
        width: 15px;
        position: absolute;
        left: 10px;
        bottom: 10px;
      }
    }
    .title {
      width: 100%;
      height: 49px;
      background: url("//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/packet/top-pic.png")
        no-repeat;
      background-size: contain;
      text-align: center;
      font-size: 17px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 49px;
    }
    .info {
      width: 100%;
      height: 153px;
      // background-color: pink;
      padding: 18px;
      position: relative;
      > p {
        font-size: 11px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
      }
    }
  }
}
</style>